export function Footer() {
  return (
    <>
      <footer className="footer-container w-full bg-zinc-800 pt-10">
        <div className="row-one">
          <p className="text-center text-xs text-stone-200">
            Disclaimer: Whiskered Words is for educational purposes only, and
            its content is not intended for commercial purposes.
          </p>
          <p className="text-center text-xs text-stone-200">
            Copyright &copy; 2023 Bryan Amora
          </p>
          <p className="mb-2 text-center text-xs text-stone-200">
            All Rights Reserved
          </p>
        </div>
      </footer>
    </>
  );
}
